import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { circleCheckmarkIcon } from '../../icons';
import { convertNumToTime } from '../core/helpers';

@Component({
    selector: 'app-time-slot-picker',
    template: `
        <ul class="time-picker">
            <li
                *ngFor="let slot of slots"
                (click)="onSlotClick(slot)"
                class="time-picker__slot"
                [ngClass]="{
                    'time-picker__slot--active': slot === currentSlot,
                    'time-picker__slot--error': hasErrors,
                    'time-picker__slot--disabled': disabled
                }"
            >
                {{ slot }}
                <i aria-hidden="true" class="button__icon">${circleCheckmarkIcon}</i>
            </li>
        </ul>

        <p class="help is-danger" *ngIf="hasErrors">
            {{ 'forms.validation_message____time_slot_picker' | translate }}
        </p>
    `,
})
export class TimeSlotPickerComponent implements OnInit, OnChanges {
    @Input() startHour? = 9;
    @Input() endHour? = 18;
    @Input() slotSizeinHour = 0.5;
    @Input() currentSlot?: string;
    @Input() hasErrors?: boolean;
    @Input() disabled = false;
    @Output() handleClick = new EventEmitter<string>();
    slots?: string[];

    ngOnInit() {
        this.constructSlots();
    }

    constructSlots() {
        const numberOfSlots = ((this.endHour || 0) - (this.startHour || 0)) / this.slotSizeinHour;
        const _slots: string[] = [];

        for (let i = 0; i < numberOfSlots; i++) {
            _slots.push(convertNumToTime((this.startHour || 0) + 1 * this.slotSizeinHour * i));
        }

        this.slots = _slots;
    }

    ngOnChanges(changes: SimpleChanges) {
        // React *ing to prop updates
        if (changes) {
            this.constructSlots();
        }
    }

    onSlotClick(slot: string) {
        if (!this.disabled) {
            this.handleClick.emit(slot !== this.currentSlot ? slot : undefined);
        }
    }
}
